export default "__VITE_ASSET__BfHvPxi1__"